import Splide from '@splidejs/splide';

const INTERVAL = 3000;
const MAX_PAGINATION_DOTS = 5;
const OPTIONS = {
  type: 'loop',
  gap: '24px',
  perPage: 3,
  pagination: true,
  autoplay: true,
  interval: INTERVAL,
  breakpoints: {
    768: {
      perPage: 1
    },
    1024: {
      perPage: 2
    }
  }
};

const addDots = (dotsToShow, dataItems, indices) => {
  indices.forEach(index => {
    if (dataItems[index] === undefined) return;
    dotsToShow.push(dataItems[index]);
  });
};

const showDots = dotsToShow => {
  dotsToShow
    .filter(dot => dot !== undefined)
    .forEach(dot => dot.button.classList.add('show'));
};

const shrinkDot = dot => {
  dot.button.classList.add('shrink');
};

const requiresPagination = data => {
  const totalDots = data.items.length;
  return totalDots > MAX_PAGINATION_DOTS;
};

const setUpPagination = data => {
  if (!requiresPagination(data)) return;

  if (!data?.list?.classList?.contains('limit-pagination')) {
    data.list.classList.add('limit-pagination');
  }
};

const handlePaginationLimit = data => {
  if (!requiresPagination(data)) return;
  const totalDots = data.items.length;

  const activeDot = data.items.find(item =>
    item?.button?.classList?.contains('is-active')
  );

  if (!activeDot) return;

  // reset
  data.items.forEach(dot => dot?.button?.classList?.remove('show', 'shrink'));

  const dotsToShow = [];

  const isPage1 = activeDot.page === 0;
  const isPage2 = activeDot.page === 1;
  const isLastPage = activeDot.page === totalDots - 1;
  const is2ndLastPage = activeDot.page === totalDots - 2;

  // add dots based on current page position
  if (isPage1) {
    addDots(dotsToShow, data.items, [
      activeDot.page,
      activeDot.page + 1,
      activeDot.page + 2,
      activeDot.page + 3,
      activeDot.page + 4
    ]);
    shrinkDot(data.items[activeDot.page + 4]);
  } else if (isPage2) {
    addDots(dotsToShow, data.items, [
      activeDot.page - 1,
      activeDot.page,
      activeDot.page + 1,
      activeDot.page + 2,
      activeDot.page + 3
    ]);
    shrinkDot(data.items[activeDot.page + 3]);
  } else if (isLastPage) {
    addDots(dotsToShow, data.items, [
      activeDot.page - 4,
      activeDot.page - 3,
      activeDot.page - 2,
      activeDot.page - 1,
      activeDot.page
    ]);
    shrinkDot(data.items[activeDot.page - 4]);
  } else if (is2ndLastPage) {
    addDots(dotsToShow, data.items, [
      activeDot.page - 3,
      activeDot.page - 2,
      activeDot.page - 1,
      activeDot.page,
      activeDot.page + 1
    ]);
    shrinkDot(data.items[activeDot.page - 3]);
  } else {
    addDots(dotsToShow, data.items, [
      activeDot.page - 2,
      activeDot.page - 1,
      activeDot.page,
      activeDot.page + 1,
      activeDot.page + 2
    ]);
    shrinkDot(data.items[activeDot.page - 2]);
    shrinkDot(data.items[activeDot.page + 2]);
  }

  showDots(dotsToShow);
};

const onPromoSectionLoad = () => {
  const promoSections = document.querySelectorAll('.promo-section__carousel');
  if (!promoSections) return;

  Array.from(promoSections).forEach(section => {
    const splide = new Splide(section, OPTIONS);
    splide.on('pagination:mounted', data => {
      setUpPagination(data);
      handlePaginationLimit(data);
    });
    splide.on('moved', data => {
      const paginationData = splide.Components.Pagination;
      handlePaginationLimit(paginationData);
    });
    splide.mount();
  });
};

export default onPromoSectionLoad;
